import React, { useState } from 'react';
import '../../style/keyPro.css';
const keyPro1 = require('../../assets/zdqyfb.png');

function KeyPro() {
    // 是否进入详情版面
    const [intoDetail, setIntoDetail] = useState(false);
    // 选中公司
    const [cCompany, setCCompany] = useState(
        {
            name: '农村公路（育才片区）改扩建',
            id: 11,
            type: '公共开发',
            text: '本项目共含4条路，总长约19.416km，对原有路面进行加宽改造，其中拆除重建道路长约4.66km，加宽改造原有道路长约14.756km。路面宽度为5.0m-7.0m，设计时速15km/h、20km/h及40km/h，双向两车道。路面结构采用沥青混凝土路面。全线共涉及涵洞65座，其中完好利用33座，拆除重建17座，加长利用15座。'
        }
    );
    // 全部数据
    const data = [
        {
            name: '农村公路（育才片区）改扩建',
            id: 11,
            type: '公共开发',
            text: '本项目共含4条路，总长约19.416km，对原有路面进行加宽改造，其中拆除重建道路长约4.66km，加宽改造原有道路长约14.756km。路面宽度为5.0m-7.0m，设计时速15km/h、20km/h及40km/h，双向两车道。路面结构采用沥青混凝土路面。全线共涉及涵洞65座，其中完好利用33座，拆除重建17座，加长利用15座。'
        },
        {
            name: '育才生态区市政路网工程项目',
            id: 22,
            type: '公共开发',
            text: '三亚市育才生态区市政路网工程项目位于三亚市育才生态区，项目总共含有14条道路，路网道路全长5.552km，立才路、玉龙路、11号路按照城市次干路标准建设，其余道路按照城市支路标准建设，玉龙路、立才路、11号路道路设计速度均采用30km/h，其余道路设计速度均采用20km/h。主要内容包括桥梁工程、道路工程、箱涵工程、给排水工程、电力通信工程、照明工程、交通工程、绿化工程等。'
        },
        {
            name: '育才水质净化厂进厂污水主干管及道路配套工程',
            id: 33,
            type: '公共开发',
            text: '项目拟新建育才水质净化厂进厂污水主干管812m，新建5条配套道路，共2502.386m，其中：S314省道（腾龙路至进厂支路）长约809.507m，道路红线宽20m，道路等级为城市次干路；腾龙路西段长约319.876m，道路红线宽20m，道路等级为城市次干路；英才路西段长约439.176m，道路红线宽15m，道路等级为城市支路；进厂支路东段长约373.827m，道路红线宽15m，道路等级为城市支路；进厂支路西段长约560m，道路红线宽10m，道路等级为城市支路。'
        },
        {
            name: '三亚市立才河水环境综合治理工程项目',
            id: 44,
            type: '公共开发',
            text: '治理范围为立才河（从育才大桥下游630m处至那介桥下游200m处）河段，治理河道长约1622.13m，其右岸堤防整治段长1690.55m，左岸堤防整治段长1629.77m。主要建设内容包括：堤防工程、慢性交通设施、生态景观绿化工程及附属工程等。'
        },
        {
            name: '育才生态区龙密村人居环境整治提升项目',
            id: 55,
            type: '公共开发',
            text: '本项目为育才生态区龙密村8个村小组的服务配套设施和基础配套设施提升改造工程，主要建设内容包括公共服务设施、道路交通、垃圾处理、公共厕所、电气等附属工程。其中：（１）服务配套设施：公共厕所4座236.68㎡、游客服务中心2座449.50㎡、室外健身器材7套、乒乓球桌37张、儿童游乐设施7套、入口节点绿化55㎡、村牌1个、活动小广场及硬化10595.10㎡、文化墙1076m。休息亭8个、座椅84组、文化小品38组、照明灯154盏、指示牌32个、垃圾堆放场清理4项、垃圾堆放场围墙495m。修缮篮球场3个、新建篮球场2个、村牌修缮2个、原有围栏修缮1727m。新增围墙435m.新增挡土墙851.7m。护栏417m。老年人日间照料中心486.76㎡、卫生室267.10㎡。（２）基础配套设施：原有水泥路加铺沥青12369.40㎡、水泥路面硬化2179.10㎡、道路拓宽2.80㎡、拆除混凝土路缘石233m、新建混凝土路缘石233m、裸露黄土整治107250m、单算雨水口提升28个、检查井提升37个、定时定点投放垃圾屋7个、雨水盖板13026m。停车场改造356.25㎡、充电桩3个。'
        },
    ]
    return (
        <div className="keyPro">
            <div className="keyPro-pic">
                <img
                    className="keyPro-pic__img"
                    src={keyPro1}
                    alt="Planets"
                />
            </div>
            <div className="keyPro-table">
                <div className="keyPro-table__name">十四五重点工程项目</div>
                {
                    !intoDetail
                    &&
                    <div className="keyPro-table__main">
                        <p className="keyPro-table__main--title">
                            <span className="title-num">项目名称</span>
                            <span className="title-name">产业类别</span>
                        </p>
                        {
                            data.map(item => (
                                < p
                                    key={item.id}
                                    className="keyPro-table__main--row">
                                    <span
                                        className="row-num"
                                        onClick={() => {
                                            setIntoDetail(true)
                                            setCCompany(item)
                                        }}
                                    >{item.name}</span>
                                    <span className="row-name">{item.type}</span>
                                </p>
                            ))
                        }
                    </div>
                }
                {
                    intoDetail
                    &&
                    <div className="keyPro-table__detail">
                        <p className="keyPro-table__detail--row">
                            <span className="name">{cCompany.name}</span>
                            <span
                                className="iconfont icon-guanbi"
                                onClick={() => {
                                    setIntoDetail(false)
                                }}
                            ></span>
                        </p>
                        <p className="keyPro-table__detail--row info">{cCompany.text}</p>
                    </div>
                }
            </div>
        </div >
    );
}

export default KeyPro;
